import { Controller } from "@hotwired/stimulus"
import { attachHereAutocomplete } from "../helpers/here_places"

export default class extends Controller {
  connect() {
    this.teardown = attachHereAutocomplete(this.element, {
      onSelect: (fields) => {
        this.element.value = fields.label || fields.street

        // Assigning .value in script fires nothing, so anything listening to the
        // field — the wizard's auto-save, a dirty guard — would never learn that
        // the address changed and would keep the half-typed query the user was
        // correcting. Both events, because listeners bind to one or the other.
        this.element.dispatchEvent(new Event("input", { bubbles: true }))
        this.element.dispatchEvent(new Event("change", { bubbles: true }))
      },
    })
  }

  disconnect() {
    if (this.teardown) this.teardown()
  }

  preventSubmit(e) {
    if (e.key == "Enter") {
      e.preventDefault()
    }
  }
}
